import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
Fancybox.defaults.Hash = false;
Fancybox.bind("[data-fancybox]", {});
